export const SUBSCRIPTION_PLAN_ADVERTISING_SLUGS = {
    comingSoon: 'coming-soon',
    defaultSelected: 'default-selected',
} as const;

export const KNOWN_SUBSCRIPTION_PLAN_ADVERTISING_SLUGS = Object.values(SUBSCRIPTION_PLAN_ADVERTISING_SLUGS);
